import React from 'react';
import { Box, TextField, IconButton, CircularProgress, Divider } from '@mui/material';
import { Send } from '@mui/icons-material';

// Composer: controlled input for sending a message on the selected thread.
// Value + send handler are owned by the Inbox page (real send mutation).
const MessageInput = ({ value = '', onChange, onSend, sending = false }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend?.();
    }
  };

  return (
    <>
      <Divider />
      <Box sx={{ display: 'flex', alignItems: 'center', p: 1.5, gap: 1 }}>
        <TextField
          fullWidth
          multiline
          maxRows={4}
          size="small"
          placeholder="Type a message..."
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <IconButton
          color="primary"
          onClick={() => onSend?.()}
          disabled={sending || !value.trim()}
        >
          {sending ? <CircularProgress size={20} /> : <Send />}
        </IconButton>
      </Box>
    </>
  );
};

export default MessageInput;
